export const ActionType = {
  SetMenuDetail: Symbol("SetMenuDetail"),
  SetTenantInfo: Symbol("SetTenantInfo"),
  SetLoginMode: Symbol("SetLoginMode"),
};
